export const priceSections = [
  `<section class="bg-light pb-5 pt-5" id="prise"> 
    <div class="container pb-4 pt-4"> 
        <div class="text-center"> 
            <h3 class="fw-bold h2 mb-3">Preise</h3>
            <p class="fw-light mb-4">Unsere flexiblen Preispläne passen sich den Bedürfnissen Ihres Unternehmens an &ndash; transparent, fair und ohne versteckte Kosten. Wählen Sie das Paket, das am besten zu Ihnen passt.</p> 
        </div>                     
        <div class="align-items-center justify-content-center row"> 
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="text-secondary"> 
                    <div class="bg-white mb-3 p-4 pricing_items__price_info rounded shadow">
                        <div class="align-items-center d-flex fw-light h5"> <span class="align-self-start currency">СHF</span> <span class="display-4 fw-bold text-dark">200</span> <span class="align-self-end term">/monat</span> 
                        </div>                                     
                        <h4 class="fw-bold h2 mb-0 text-dark"><p><strong data-start="180" data-end="191">Starter</strong></p></h4>
                    </div>                                 
                    <div class="bg-white p-4 rounded shadow"> 
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-2 pt-2">Ideal für Freelancer und kleine Unternehmen, die schnell und einfach digitale Rechnungen erstellen möchten.</li>                                         
                        </ul>                                     <a href="index.html#contact" class="btn d-block w-100 btn-outline-dark rounded-pill"><strong data-start="319" data-end="336">Jetzt starten</strong></a> 
                    </div>                                 
                </div>                             
            </div>                         
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="text-secondary"> 
                    <div class="bg-primary mb-3 p-4 pricing_items__price_info rounded shadow text-white"> 
                        <div class="align-items-center d-flex fw-light h5"> <span class="align-self-start currency">СHF</span> <span class="display-4 fw-bold">600</span> <span class="align-self-end term">/monat</span> 
                        </div>                                     
                        <h4 class="fw-bold h2 mb-0">Business</h4> 
                    </div>                                 
                    <div class="bg-primary p-4 rounded shadow text-white"> 
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-2 pt-2">Perfekt für wachsende Unternehmen mit erweiterten Funktionen wie automatisierte Finanzberichte und Teamzugang.</li>                                         
                        </ul>                                     <a href="index.html#contact" class="btn d-block w-100 btn-light rounded-pill">Jetzt starten</a> 
                    </div>                                 
                </div>                             
            </div>                         
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="text-secondary"> 
                    <div class="bg-white mb-3 p-4 pricing_items__price_info rounded shadow"> 
                        <div class="align-items-center d-flex fw-light h5">
                            <span class="align-self-start currency">СHF</span> <span class="display-4 fw-bold text-dark">800</span> <span class="align-self-end term">/monat</span>
                        </div>                                     
                        <h4 class="fw-bold h2 mb-0 text-dark">Premium</h4> 
                    </div>                                 
                    <div class="bg-white p-4 rounded shadow"> 
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-2 pt-2">Für Unternehmen, die höchste Effizienz und volle Kontrolle benötigen &ndash; inklusive Prioritätssupport und individueller Anpassungen.</li>                                         
                        </ul>                                     <a href="index.html#contact" class="btn d-block w-100 btn-outline-dark rounded-pill">Jetzt starten</a> 
                    </div>                                 
                </div>                             
            </div>                         
        </div>                     
    </div>                 
</section>`,
  `<section class="bg-light pb-5 pt-5 text-center"> 
    <div class="container pb-4 pt-4"> 
        <h3 class="fw-bold h2 mb-3">Unsere Preise</h3>
        <p class="fw-light mb-4">Wir bieten flexible Preisoptionen, die sich an Ihren individuellen Bedürfnissen und Zielen orientieren. Wählen Sie das passende Paket und profitieren Sie von professioneller Unterstützung auf jedem Schritt Ihres Erfolgswegs.</p> 
        <div class="align-items-center justify-content-center row"> 
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="bg-white overflow-hidden pt-4 rounded-3 shadow text-secondary"> 
                    <div class="bg-light pb-5 ps-4 position-relative pe-4 pt-4">
                        <h4 class="fw-bold h3 mb-3 text-dark text-uppercase">StarterKompass</h4>
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-1 pt-1">Perfekt für junge Unternehmen und Start-ups, die eine solide Grundlage für ihre Finanzstrategie schaffen wollen.</li>                                     
                        </ul>
                        <div class="align-items-center d-flex fw-light h5 justify-content-center mb-4">
                            <span class="align-self-start currency">CHF</span> <span class="fw-bold h1 text-dark">499</span> <span class="align-self-end term">/monat</span>
                        </div>
                        <a href="contact.html" class="btn btn-primary ps-5 pe-5 rounded-pill text-uppercase">Jetzt starten</a>
                    </div>                             
                </div>                         
            </div>                     
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="bg-white overflow-hidden pt-4 rounded-3 shadow text-secondary"> 
                    <div class="bg-primary pb-5 ps-4 position-relative pe-4 pt-4 text-white">
                        <h4 class="fw-bold h3 mb-3 text-uppercase">WachstumsNavigator</h4>
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-1 pt-1">Ideal für wachsende Unternehmen, die ihre Prozesse optimieren und gezielt in die nächste Erfolgsstufe aufsteigen möchten.</li>                                     
                        </ul>
                        <div class="align-items-center d-flex fw-light h5 justify-content-center mb-4"> <span class="align-self-start currency">CHF</span> <span class="fw-bold h1">1199</span> <span class="align-self-end term">/monat</span> 
                        </div>
                        <a href="contact.html" class="btn btn-light pe-5 ps-5 rounded-pill text-uppercase">Mehr erfahren</a>
                    </div>                             
                </div>                         
            </div>                     
            <div class="col-lg-4 col-md-6 py-3"> 
                <div class="bg-white overflow-hidden pt-4 rounded-3 shadow text-secondary"> 
                    <div class="bg-light pb-5 ps-4 position-relative pe-4 pt-4">
                        <h4 class="fw-bold h3 mb-3 text-dark text-uppercase">ZukunftsArchitekt</h4>
                        <ul class="list-unstyled mb-4"> 
                            <li class="pb-1 pt-1">Für etablierte Unternehmen, die langfristige Strategien und maßgeschneiderte Lösungen für nachhaltiges Wachstum suchen.</li>                                     
                        </ul>
                        <div class="align-items-center d-flex fw-light h5 justify-content-center mb-4"> <span class="align-self-start currency">CHF</span> <span class="fw-bold h1 text-dark">2499</span> <span class="align-self-end term">/monat</span> 
                        </div>
                        <a href="contact.html" class="btn btn-primary ps-5 pe-5 rounded-pill text-uppercase">Angebot anfordern</a>
                    </div>                             
                </div>                         
            </div>                     
        </div>                 
    </div>             
</section>`,
  // 1 — базовий, світлий
  `<section id="price" class="bg-light py-5 text-center">
    <div class="container py-4">
      <h2 class="h6 mb-1 text-primary text-uppercase">Strukturmodule</h2>
      <h3 class="fw-bold h2 mb-3">Wählen Sie das passende Setup</h3>
      <p class="fw-light mb-4">Anpassbare Module für Teams jeder Grösse – klar strukturiert, sicher und effizient.</p>
      <div class="row justify-content-center">
        <div class="col-md-4 py-3">
          <div class="bg-white rounded-3 shadow p-5">
            <h4 class="fw-bold text-uppercase text-dark mb-3">Basis</h4>
            <ul class="list-unstyled text-secondary mb-4">
              <li>10 Benutzerzugänge</li><li>20 GB Daten</li><li>Standardauswertungen</li><li>E-Mail Support</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 24 <small class="fs-6 fw-light">/Monat</small></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-white rounded-3 shadow p-5 border border-primary">
            <h4 class="fw-bold text-uppercase text-dark mb-3">Team</h4>
            <ul class="list-unstyled text-secondary mb-4">
              <li>80 Benutzer</li><li>200 GB Daten</li><li>Erweiterte Steuerung</li><li>Priorisierte Betreuung</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 49 <small class="fs-6 fw-light">/Monat</small></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-white rounded-3 shadow p-5">
            <h4 class="fw-bold text-uppercase text-dark mb-3">Erweitert</h4>
            <ul class="list-unstyled text-secondary mb-4">
              <li>Unbegrenzte Benutzer</li><li>1 TB Daten</li><li>Automatisierung</li><li>Individuelle Ansichten</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 84 <small class="fs-6 fw-light">/Monat</small></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 2 — темна версія
  `<section id="price" class="bg-dark text-white py-5 text-center">
    <div class="container">
      <h2 class="h6 text-warning text-uppercase mb-2">Setup Varianten</h2>
      <h3 class="fw-bold h2 mb-3">Strukturiert. Sicher. Skalierbar.</h3>
      <p class="text-light mb-5">WhiteEx-Module wachsen mit Ihrem Unternehmen – flexibel und transparent.</p>
      <div class="row justify-content-center">
        <div class="col-md-4 py-3">
          <div class="bg-black border border-secondary rounded-4 p-5">
            <h4 class="fw-bold text-warning mb-3">Basis</h4>
            <ul class="list-unstyled mb-4">
              <li>10 Benutzer</li><li>20 GB Speicher</li><li>Grundauswertung</li><li>Support per E-Mail</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 24<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-warning rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-primary text-white rounded-4 p-5">
            <h4 class="fw-bold mb-3">Team</h4>
            <ul class="list-unstyled mb-4">
              <li>80 Benutzer</li><li>200 GB Speicher</li><li>Realtime Tasks</li><li>Priorisierter Support</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 49<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-light rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-secondary text-white rounded-4 p-5">
            <h4 class="fw-bold mb-3">Erweitert</h4>
            <ul class="list-unstyled mb-4">
              <li>Unbegrenzte Benutzer</li><li>1 TB Speicher</li><li>API Integration</li><li>Direkter Supportkanal</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 79<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-warning rounded-pill px-5">Kontakt</a>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 3 — синя градієнтна секція
  `<section id="price" class="text-white py-5" style="background:linear-gradient(120deg,#1c1f24,#3a6ea5,#3fb3c3);">
    <div class="container text-center">
      <h2 class="h6 text-uppercase text-light mb-2">Preisoptionen</h2>
      <h3 class="fw-bold h2 mb-3">Flexible Lösungen für jede Phase</h3>
      <p class="mb-5 text-light">Einfach starten oder Ihr System erweitern – wählen Sie das Modell, das zu Ihnen passt.</p>
      <div class="row justify-content-center">
        <div class="col-md-4 py-3">
          <div class="bg-white text-dark rounded-3 shadow p-5">
            <h4 class="fw-bold text-uppercase">Start</h4>
            <ul class="list-unstyled mb-4">
              <li>5 Benutzer</li><li>10 GB Daten</li><li>E-Mail Support</li><li>Basismodul</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 15<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-light text-dark rounded-3 shadow p-5 border border-white">
            <h4 class="fw-bold text-uppercase">Pro</h4>
            <ul class="list-unstyled mb-4">
              <li>100 Benutzer</li><li>500 GB Daten</li><li>Automatisierung</li><li>Premium Support</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 79<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-white text-dark rounded-3 shadow p-5">
            <h4 class="fw-bold text-uppercase">Enterprise</h4>
            <ul class="list-unstyled mb-4">
              <li>Unbegrenzte Benutzer</li><li>1 TB Daten</li><li>API Integration</li><li>Priorisierter Service</li>
            </ul>
            <h2 class="fw-bold mb-4">CHF 99<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-primary rounded-pill px-5">Kontakt</a>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 4 — біла секція з 4 кольоровими планами
  `<section id="price" class="bg-white py-5 text-center">
    <div class="container">
      <h2 class="h6 text-primary text-uppercase mb-1">Module</h2>
      <h3 class="fw-bold h2 mb-3">Klare Struktur. Klare Preise.</h3>
      <p class="text-muted mb-5">WhiteEx bietet modulare Systeme für jede Unternehmensstruktur.</p>
      <div class="row justify-content-center">
        <div class="col-md-3 py-3">
          <div class="border rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-uppercase mb-3">Basis</h4>
            <p class="text-secondary">Ideal für kleine Teams</p>
            <h2 class="fw-bold">CHF 19</h2>
            <a href="contact.html" class="btn btn-outline-primary rounded-pill mt-3">Kontakt</a>
          </div>
        </div>
        <div class="col-md-3 py-3">
          <div class="border border-primary rounded-3 shadow p-4 h-100">
            <h4 class="fw-bold text-uppercase mb-3 text-primary">Standard</h4>
            <p class="text-secondary">Für mittlere Organisationen</p>
            <h2 class="fw-bold text-primary">CHF 39</h2>
            <a href="contact.html" class="btn btn-primary rounded-pill mt-3">Kontakt</a>
          </div>
        </div>
        <div class="col-md-3 py-3">
          <div class="border border-dark rounded-3 shadow p-4 h-100">
            <h4 class="fw-bold text-uppercase mb-3">Pro</h4>
            <p class="text-secondary">Erweiterte Automatisierung</p>
            <h2 class="fw-bold">CHF 69</h2>
            <a href="contact.html" class="btn btn-dark rounded-pill mt-3">Kontakt</a>
          </div>
        </div>
        <div class="col-md-3 py-3">
          <div class="border border-warning rounded-3 shadow p-4 h-100">
            <h4 class="fw-bold text-uppercase text-warning mb-3">Enterprise</h4>
            <p class="text-secondary">Unbegrenzte Nutzer</p>
            <h2 class="fw-bold text-warning">CHF 99</h2>
            <a href="contact.html" class="btn btn-warning text-dark rounded-pill mt-3">Kontakt</a>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 5 — темно-синій блок із білими картками (тепер 3 варіанти)
  `<section id="price" class="py-5" style="background-color:#1c1f24;">
    <div class="container text-center text-white">
      <h2 class="h6 text-uppercase text-light mb-1">WhiteEx Modelle</h2>
      <h3 class="fw-bold h2 mb-3">Effizienz für jedes Budget</h3>
      <p class="text-secondary mb-5">Wählen Sie zwischen Basismodul, Team oder erweiterten Strukturen.</p>
      <div class="row justify-content-center">
        <div class="col-md-4 py-3">
          <div class="bg-white text-dark rounded-3 p-5">
            <h4 class="fw-bold mb-3 text-uppercase">Basis</h4>
            <ul class="list-unstyled text-secondary mb-4">
              <li>15 Benutzer</li><li>50 GB</li><li>Standard Support</li><li>Dashboard Zugriff</li>
            </ul>
            <h2 class="fw-bold">CHF 39<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-dark rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-white text-dark rounded-3 p-5">
            <h4 class="fw-bold mb-3 text-uppercase">Team</h4>
            <ul class="list-unstyled text-secondary mb-4">
              <li>80 Benutzer</li><li>250 GB</li><li>Realtime Updates</li><li>Priorisierter Support</li>
            </ul>
            <h2 class="fw-bold">CHF 59<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-dark rounded-pill px-5">Kontakt</a>
          </div>
        </div>
        <div class="col-md-4 py-3">
          <div class="bg-warning text-dark rounded-3 p-5">
            <h4 class="fw-bold mb-3 text-uppercase">Premium</h4>
            <ul class="list-unstyled mb-4">
              <li>Unbegrenzt Benutzer</li><li>1 TB</li><li>API Integration</li><li>Vorrangige Betreuung</li>
            </ul>
            <h2 class="fw-bold">CHF 99<span class="fs-6 fw-light">/Monat</span></h2>
            <a href="contact.html" class="btn btn-dark rounded-pill px-5">Kontakt</a>
          </div>
        </div>
      </div>
    </div>
  </section>`,
];
